globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.FontOrdering = (function()
{
  function FontOrdering() {
    var $indexContainer = $('.page-view-index-fonts');
    if($indexContainer.length) {
      this.$container = $indexContainer;
      this.refConfig =
      {
        handlerCls: '.font-handle',
        sortableContainerId: '#font-sortable',
        draggableCls: '.font-object'
      }
      this.init();
    }
  }

  FontOrdering.prototype =
  {
    init: function()
    {
      var self = this;
      this.$container.find(this.refConfig.sortableContainerId).sortable({
        items: self.refConfig.draggableCls,
        handle: self.refConfig.handlerCls,
        helper: "clone",
        axis: "y",
        placeholder: "font-object target",
        forcePlaceholderSize: true,
        stop: function(event, ui) {
          var $font = $(ui.item);
          var font = {
            id: $font.data('id'),
            position: $font.index()
          }
          console.log(font);
          self.saveOrder(font, function(msg){
            self.callbackSuccess(msg);
          }, function(){
            self.callbackError(msg);
          });
        }
      })
    },
    saveOrder: function(font, success, error)
    {
      var self = this;
      $.ajax({
        url: '/fonts/'+font.id+'/reorder',
        method: "PATCH",
        data: { font_order_position: font.position },
        dataType: 'json',
        success: function(data){
          if(data.response) {
            success(data.message);
          }
        },
        error: function(data){
          error(data.message);
        }
      });
    },
    callbackSuccess: function(msg)
    {
      this.flash('notice', msg);
    },
    callbackError: function(msg)
    {
      this.flash('alert', msg);
    },
    flash: function(type, msg)
    {
      var ico = (type == 'notice') ? 'check' : 'times';
      var $flash = $('<div class="flash-container animated fadeInRight">\
                        <div class="flash ajax flash-'+type+'">\
                        	<span class="flash-icon">\
                        	  <i class="fa fa-'+ico+'"></i>\
                        	</span>\
                        	<span class="flash-message">' + msg +  '</span>\
                        </div>\
                      </div>');

      $flash.appendTo($('body'));
      setTimeout(function(){
        $flash.removeClass('fadeInLeft').addClass('fadeOutRight');
      }, 3000);
      setTimeout(function(){
        $flash.remove();
      }, 3200);
    }
  }
  return FontOrdering;
})();

masterBackoffice.FontChangeClass = (function()
{
  function FontChangeClass() {
    var $indexContainer = $('.page-view-index-fonts');
    if($indexContainer.length) {
      this.$container = $indexContainer;
      this.refConfig =
      {
        selectClassFont: '.select-font-class',
      }
      this.init();
    }
  }

  FontChangeClass.prototype =
  {
    init: function()
    {
      $(this.refConfig.selectClassFont).on('change',function(){
        $(this).parents('form').submit();
      });
    }
  }
  return FontChangeClass;
})();
